import { KnowledgeChannel } from './types';
import { KnowledgeLocale } from './knowledgeCopy';

export interface KnowledgeSiteConfig {
  siteName: string;
  logoSrc: string;
  navBrandLabel: string;
}

export function getKnowledgeSiteConfig(
  channel: KnowledgeChannel,
  locale: KnowledgeLocale
): KnowledgeSiteConfig {
  if (channel === 'help') {
    return {
      siteName:
        locale === 'fr-fr'
          ? 'Service client Urban Massage'
          : 'Urban Massage Customer Service',
      logoSrc: '/assets/images/knowledge/logo-urban-help.png',
      navBrandLabel: locale === 'fr-fr' ? 'URBAN' : 'URBAN',
    };
  }

  return {
    siteName: locale === 'fr-fr' ? 'Aide Hero' : 'Hero Help Center',
    logoSrc: '/assets/images/knowledge/logo-hero-help.png',
    navBrandLabel: 'HOME',
  };
}
